import React, { useState, useEffect } from "react";
import { Container, Nav, Navbar, NavDropdown, Button } from "react-bootstrap";
import { isMobileOrTablet } from "../Utils";
import { Link } from 'react-router-dom';
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";
import CustomButton from '../CustomButton';
import "./NavigationBar.css";

export default function NavigationBar() {
    const [navbar, setNavbar] = useState(false);
    const isMobileOrTabletDevice = isMobileOrTablet();
    const [expanded, setExpanded] = useState(false);
    const imgCDNURL = process.env.REACT_APP_CDN;

    let prevScrollPos = window.scrollY;

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScroll = () => {
        const currentScrollPos = window.scrollY;
        const menuNavbar = document.getElementById("menuNavbar");
        if (currentScrollPos === 0) {
            menuNavbar.classList.remove("navbarTransition");
            setNavbar(false);
        } else {
            if (prevScrollPos > currentScrollPos) {
                setNavbar(true);
            } else if (prevScrollPos < currentScrollPos) {
                if (!isMobileOrTabletDevice) {
                    setNavbar(true);
                } else {
                    setNavbar(false);
                    menuNavbar.classList.add("navbarTransition");
                }
            }
        }
        prevScrollPos = currentScrollPos;
    };

    const handleMenuClick = () => {
        setExpanded(false);
        setNavbar(false);
    };

    return (
        <>
            <div>
                <Navbar
                    id="menuNavbar"
                    collapseOnSelect
                    expanded={expanded}
                    onToggle={() => setExpanded(!expanded)}
                    onSelect={() => setExpanded(false)}
                    expand="lg"
                    fixed="top"
                    bg="dark"
                    variant="dark"
                    className={navbar ? "navbar active" : "navbar"}
                >
                    <Container className="navbar-container">
                        <Navbar.Brand className="navbrand-logo">
                            <div className="d-flex">
                                <div>
                                    <Link to="/" onClick={() => setExpanded(false)}>
                                        <img
                                            src={imgCDNURL + "evolutionai/images/evolutionai.webp"}
                                            alt="EvolutionAI logo"
                                            width="494px"
                                            height="184px"
                                            className="main_logo img-fluid"
                                        />
                                    </Link>
                                </div>

                            </div>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav>
                            <div className="mobile-AccessibilityMenu-show">
                    <UserWayAccessibilityMenu color="white" width={40} height={40} />
                </div>
                                <Nav.Link as={Link} to="/" onClick={handleMenuClick}>
                                    HOME
                                </Nav.Link>
                                <NavDropdown title="ABOUT">
                                    <NavDropdown.Item as={Link} to={"/why-evolutionai"} onClick={handleMenuClick}>Why EvolutionAI</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to={"/testimonials"} onClick={handleMenuClick}>Testimonials</NavDropdown.Item>
                                </NavDropdown>
                                <NavDropdown title="RESOURCES">
                                    <NavDropdown.Item as={Link} to={"/loan-programs"} onClick={handleMenuClick}>Loan Programs</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to={"https://www.swmc.com/angelai/calculators"} target="_blank" rel="noopener noreferrer" onClick={handleMenuClick}>Mortgage Calculator</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to={"https://www.swmc.com/blog/"} target="_blank" rel="noopener noreferrer" onClick={handleMenuClick}>Blog</NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link
                                    href="https://askangel.ai/evolution"
                                    target="_blank"
                                    onClick={handleMenuClick}
                                >
                                    ANGELAI
                                </Nav.Link>
                                <Nav.Link as={Link} to="/contact" onClick={handleMenuClick}>
                                    CONTACT
                                </Nav.Link>
                                <Nav.Link as="div">
                                    <div className="navbar-pricing-btn">
                                        <CustomButton as={Link} to="https://www.swmc.com/ApplyNow/?c=evolution" target="_blank" onClick={handleMenuClick}>
                                            APPLY NOW
                                        </CustomButton>
                                    </div>
                                </Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                        <div className="desktop-AccessibilityMenu-show">
                            <UserWayAccessibilityMenu color="white" width={40} height={40} />
                        </div>

                    </Container>
                </Navbar>
                
            </div>
        </>
    );
}
